import { Component, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { IAppliedFilter } from 'src/app/interface/applied-filter';
import { IFilterResponse } from 'src/app/interface/filter-response';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';
import { ApplicationService } from 'src/app/services/http/application.service';
import { ApplicationCreateEditComponent } from './application-create-edit/application-create-edit.component';

export interface UserElement {
  id: number;
  dateCreated: Date;
  name: string;
  role: string;
  email: string;
  phoneNumber: string;
  status: string;
}

@Component({
  selector: 'app-application-management',
  templateUrl: './application-management.component.html',
  styleUrls: ['./application-management.component.scss']
})
export class ApplicationManagementComponent {
  @ViewChild(ApplicationCreateEditComponent) popupComponentRef!: ApplicationCreateEditComponent;
  @ViewChild(ModalConfirmComponent) confirmModal!: ModalConfirmComponent;

  appliedFilters: IAppliedFilter[] = []
  searchInput: string = '';
  public currentPage: number = 1;
  public pageSize: number = 10;
  public count: number = 0;
  public selectedUser: any = {
    id: "",
    name: '',
    applications: [],
    role: 0,
    email: '',
  };;
  public applications: any[] = []

  ngOnInit(): void {
    this.reloadTable();
  }

  constructor(private applicationService: ApplicationService,
    private toastr: ToastrService) { }

  handleChangeFilter(appliedFilters: IFilterResponse) {
    this.appliedFilters = appliedFilters.filters;
    this.searchInput = appliedFilters.searchFilter;
    this.currentPage = 1;
    this.reloadTable()
  }

  pageChange(value: number) {
    this.currentPage = value
    this.reloadTable()
  }

  resetSelectedBU() {
    this.selectedUser = {
      id: "",
      name: '',
      applications: [],
      role: 0,
      email: '',
    };
  }

  reloadTable(page: any = null) {
    if (page)
      this.currentPage = page;

    this.resetSelectedBU();

    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      search: this.searchInput
    };

    this.applicationService.getAll(obj).subscribe(response => {
      this.applications = response.data.data;
      this.count = response.data.count;
    }, error => {
      this.toastr.error('An error occurred.');
    });
  }

  selectApp (id?: any) {
    if (id != null) {
      let tempUser = this.applications.find(x => x.id === id);
      this.openTab(tempUser);
    }
    else
      this.openTab();

  }

  openTab(data?: any) {
    if (data) {
      this.popupComponentRef.changeState(1, data);
    }
    else {
      this.popupComponentRef.changeState(1);
    }
  }

  openTabDelete(id: any) {
    this.selectedUser = this.applications.find(x => x.id === id);
    this.confirmModal.changeState();
  }

  cancelDelete() {

  }
}
